import React, { useEffect } from "react";
import classNames from "classnames";
import Styles from "./index.module.scss";


function CustomInputField({
  defaultValue,
  value,
  hasError,
  type,
  name,
  disable,
  readOnly,
  placeholder,
  enterKeyHint = "enter",
  onChange,
  onBlur,
  autoComplete,
  autoFocus = "false",
  errorMsg,
  actionButtons,
  id,
}) {
  useEffect(() => {
    // Define a function to prevent the default scroll behavior
    const handleWheel = (e) => {
      e.preventDefault();
    };

    // Find all number input elements in the document
    const numberInputs = document.querySelectorAll('input[type="number"]');

    // Attach the handleWheel function as an event listener to each number input
    numberInputs.forEach((input) => {
      input.addEventListener('wheel', handleWheel, { passive: false });
    });

    // Clean up by removing the event listeners when the component unmounts
    return () => {
      numberInputs.forEach((input) => {
        input.removeEventListener('wheel', handleWheel);
      });
    };
  }, []); // The empty dependency array ensures that this effect runs once, like componentDidMount

  const todayDate = new Date().toISOString().split("T")[0];

  return (
    <div className={Styles.wrapper}>
      <input
        className={classNames(Styles.input, {
          [Styles.hasError]: hasError,
        })}
        id={id}
        type={type}
        name={name}
        disabled={disable}
        readOnly={readOnly}
        placeholder={placeholder}
        autoComplete={autoComplete}
        // autoFocus={autoFocus}
        // defaultValue={defaultValue}
        value={value}
        // enterKeyHint={enterKeyHint}
        // onKeyUp={onChange}
        onChange={onChange}
        onBlur={onBlur}
        max={type === "date" ? todayDate : undefined}
        // required
      />
      {placeholder && <label className={Styles.label}>{placeholder}</label>}
      {errorMsg && <span className={Styles.error}>{errorMsg}</span>}
      {!!actionButtons?.length &&
        actionButtons.map((actionButton, index) => actionButton(index))}
    </div>
  );
}

export default CustomInputField;
